import React from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Environment } from '@react-three/drei';
import CarModel from './CarModel';

const Home = () => {
  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.logo}>Bergkulla</h1>
      </header>

      <main style={styles.main}>
        <div style={styles.descriptionContainer}>
          <div style={styles.descriptionCard}>
            <h2 style={styles.descriptionTitle}>Om mitt arbete</h2>
            <p style={styles.descriptionText}>
              Denna bilen wrappade jag 2025 med en grå ton som passar en bmw m6
            </p>
          </div>
        </div>

        <div style={styles.viewerContainer}>
          <Canvas camera={{ position: [0, 2, 7], fov: 85 }}>
            <CarModel />
            <OrbitControls enableZoom={false} />
            <Environment preset="sunset" />
          </Canvas>
        </div>
      </main>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(135deg, rgb(205, 130, 38), #a1a1a1)',
    position: 'relative',
  },
  header: {
    width: '100%',
    padding: '10px 20px',
    backgroundColor: '#333',
    color: '#fff',
    textAlign: 'center',
    zIndex: 1,
  },
  logo: {
    margin: 0,
    fontSize: '2rem',
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif',
  },
  main: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    padding: '0 20px',
    position: 'relative',
  },
  viewerContainer: {
    flex: 1,
    width: '70%',
    height: '80%',
  },
  descriptionContainer: {
    position: 'absolute',
    top: '10%',
    width: '50%',
    zIndex: 2,
  },
  descriptionCard: {
    padding: '15px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
  },
  descriptionTitle: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  descriptionText: {
    fontSize: '0.875rem',
    color: '#333',
  },
};

export default Home;
